export default __webpack_public_path__ + "static/media/codingBg.dd9f0d5a.jpg";